import parse from 'html-react-parser';
import { getText } from '../../utils/languageUtils';



const SelectGrade = ({ selectedGrade, setSelectedGrade, language, gradeList, translationData }) => {
    const translations = translationData?.baseline || {};
    const handleAgeChange = (e) => {
        setSelectedGrade(e.target.value);
    };

    return (
        <div className="row justify-content-md-center mb-4">
            <div className="col col-lg-2"></div>
            <div className="col-md-auto">
                <select
                    className="form-select"
                    aria-label="Default select example"
                    defaultValue={selectedGrade}
                    onChange={handleAgeChange}
                    disabled
                >
                    <option value="" >{getText(translations.choose_grade, language)}</option>
                    {gradeList?.map((item, index) => (
                        <option value={item?.id}>{item?.title}</option>
                    ))}
                </select>
            </div>
            <div className="col col-lg-2"></div>
        </div>
    );
};


const SelectGender = ({ selectGender, setSelectedGender, language, translationData }) => {
    const translations = translationData?.baseline || {};
    const handleGenderChange = (e) => {
        setSelectedGender(e.target.value);
    };

    return (
        <div className="row justify-content-md-center mb-4">
            <div className="col col-lg-2"></div>
            <div className="col-md-auto">
                <select
                    className="form-select"
                    aria-label="Default select example"
                    defaultValue={selectGender}
                    onChange={handleGenderChange}
                >
                    <option value="" >{getText(translations?.choose_gender, language)}</option>
                    <option value={1}>{getText(translations?.gender_op_1, language)}</option>
                    <option value={2}>{getText(translations?.gender_op_2, language)}</option>
                    <option value={4}>{getText(translations?.gender_op_3, language)}</option>
                    <option value={3}>{getText(translations?.gender_op_4, language)}</option>

                </select>
            </div>
            <div className="col col-lg-2"></div>
        </div>
    );
};

const QuizIntro = ({
    data,
    gradeList,
    selectedGrade,
    setSelectedGrade,
    selectGender,
    setSelectedGender,
    language,
    startSection1,
    translationData
}) => {
    return (
        <div className="container text-center">
            <div className="row justify-content-md-center">
                <div className="col col-lg-2">

                </div>
                <div className="col-md-auto">
                    <div className="sectionsBox">
                        <p className="mb-0 text-center">{getText(data?.baseline_summary?.title, language)}</p>
                    </div>
                    <div className="contentbox mb-4 mt-3">
                        {getText(data?.baseline_summary?.description, language).length > 0 && <div className="content_safty ">
                            {parse(getText(data?.baseline_summary?.description, language))}
                        </div>
                        }
                        {getText(data?.baseline_summary?.instruction, language).length > 0 && <div className="content_safty_ol_li ">
                            {parse(getText(data?.baseline_summary?.instruction, language))}

                        </div>
                        }

                    </div>



                </div>
                <div className="col col-lg-2">

                </div>
            </div>
            {/* <SelectAge selectedAge={selectedAge} setSelectedAge={setSelectedAge} language={language} studentProgress={studentProgress} /> */}
            <SelectGrade gradeList={gradeList} setSelectedGrade={setSelectedGrade} selectedGrade={selectedGrade} language={language} translationData={translationData} />
            <SelectGender selectGender={selectGender} setSelectedGender={setSelectedGender} language={language} translationData={translationData} />
            <div className="row justify-content-md-center">
                <div className="col col-lg-2">

                </div>
                <div className="col-md-auto">
                    <button onClick={() => { startSection1(data?.baseline_summary?.url) }} type="button" className="btn btn-danger  custom-button-next">
                        {getText(translationData?.baseline?.next, language)}
                    </button>
                </div>
                <div className="col col-lg-2">

                </div>
            </div>
        </div>
    )
}

export default QuizIntro
